
import ResumeComponent from './Components/ResumeComponent';

function App() {
  return (
    <div className="ResumeComponent">
      <ResumeComponent/>
    </div>
  );
}

export default App;